export const FileTypes = {
  pdf: 'pdf',
  docx: 'docx'
} as const

export type FileType = typeof FileTypes[keyof typeof FileTypes]
